module.exports = __webpack_public_path__ + "667cde648f246920babf411a3af29771.svg";